<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CLLlxe/tc-custom/9780253052681.jpg?1737770500568" alt="This image is the cover for the book Mighty Fine Road"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mighty Fine Road
      </h1>
      <p class="bookDescription body article font2">
        <b>“Grant has once again hit a home run . . . a detailed but readable history of the Chicago, Rock Island and Pacific, a major Midwestern railroad.” —Carlos A. Schwantes, St. Louis Mercantile Library Professor Emeritus</b><br/><br/>The Chicago, Rock Island &amp; Pacific Railroad’s history is one of big booms and bigger busts. When it became the first railroad to reach and then cross the Mississippi River in 1856, it emerged as a leading American railroad company. But after aggressive expansion and a subsequent change in management, the company struggled and eventually declared bankruptcy in 1915. What followed was a cycle of resurrections and bankruptcies; a grueling, ten-year, ultimately unsuccessful battle to merge with the Union Pacific; and the Rock Island’s final liquidation in 1981. But today, long after its glory days and eventual demise, the “Mighty Fine Road” has left behind a living legacy of major and feeder lines throughout the country. In his latest work, railroad historian H. Roger Grant offers an accessible, gorgeously illustrated, and comprehensive history of this iconic American railroad.<br/><br/><b>“This handsome, well-illustrated book merits the attention of any reader interested in the history of Iowa. And just as important, the book reminds us of the importance of railroads to the history and vitality of American society. All aboard!” —<i>Iowa City Press-Citizen</i></b><br/><br/><b>“<i>A Mighty Fine Road</i> lays out the amazing, yet heartbreaking history of the railroad I loved. The historical opportunities and disappointments of the Rock Island is clearly explained in Grant’s book, with visionaries keeping the dream moving forward, yet damaged and constrained by greed and lack of vision with the next management regime.” —Dan Sabin, President, Iowa Northern Railway Company</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. Roger Grant
      </h2>
      
      <p class="authorDescription body article"><P>H. Roger Grant is author of numerous books, including <I>Visionary Railroader</I>, <I>John W. Barriger III</I>, <I>Railroaders without Borders</I>, and <I>Railroads and the American People</I>. He is Kathryn and Calhoun Lemon Professor of History at Clemson University.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3dcf0c64